// === Wicca Vibes · Mobile banner image cycler ===
document.querySelectorAll('.banner-mobile-cycle[data-cycle-interval]').forEach(function(el) {
  var slides = el.querySelectorAll('.bmc-slide');
  if (slides.length < 2) return;
  var ms = parseInt(el.dataset.cycleInterval, 10) || 3000;
  var i = 0;

  function hydrateSlide(slide, done) {
    var img = slide.querySelector('img[data-bmc-src]');
    if (!img || img.dataset.bmcLoaded === 'true') {
      if (done) done();
      return;
    }

    function finish() {
      img.dataset.bmcLoaded = 'true';
      if (done) done();
    }

    img.addEventListener('load', finish, { once: true });
    img.srcset = img.dataset.bmcSrcset || '';
    img.src = img.dataset.bmcSrc;

    if (img.complete) finish();
  }

  setInterval(function() {
    var next = (i + 1) % slides.length;
    hydrateSlide(slides[next], function() {
      slides[i].classList.remove('bmc-slide--active');
      i = next;
      slides[i].classList.add('bmc-slide--active');
    });
  }, ms);
});

// === Wicca Vibes · defer secondary product-card images ===
(function() {
  function hydrateSecondaryImages(scope) {
    var root = scope || document;
    root.querySelectorAll('img[data-card-secondary-src]').forEach(function(img) {
      if (img.dataset.cardSecondaryLoaded === 'true') return;
      img.srcset = img.dataset.cardSecondarySrcset || '';
      img.src = img.dataset.cardSecondarySrc;
      img.dataset.cardSecondaryLoaded = 'true';
    });
  }

  if (window.matchMedia && window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          hydrateSecondaryImages(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '350px 0px' });

    document.querySelectorAll('.product-card-wrapper').forEach(function(card) {
      observer.observe(card);
    });
  }

  document.addEventListener('mouseenter', function(event) {
    var card = event.target.closest && event.target.closest('.product-card-wrapper');
    if (card) hydrateSecondaryImages(card);
  }, true);

  document.addEventListener('focusin', function(event) {
    var card = event.target.closest && event.target.closest('.product-card-wrapper');
    if (card) hydrateSecondaryImages(card);
  });
})();

// === Wicca Vibes · Announcement Bar rotator ===
document.querySelectorAll('.ann-bar').forEach(initAnnBar);

// Fix body offset for fixed-position bar
function syncAnnBarHeight() {
  const bar = document.querySelector('.ann-bar');
  if (!bar) return;
  const h = bar.offsetHeight + 'px';
  document.documentElement.style.setProperty('--ann-bar-height', h);
  document.body.style.paddingTop = h;
}
document.addEventListener('DOMContentLoaded', syncAnnBarHeight);
window.addEventListener('resize', syncAnnBarHeight);

function initAnnBar(bar) {
  const messages = bar.querySelectorAll('.ann-msg');
  if (messages.length <= 1) return;

  // letter_spacing schema stores value as integer (e.g. 26 = 0.26em) — divide by 100
  // rotation_interval is already multiplied by 1000 in Liquid
  const interval = parseInt(bar.dataset.rotationInterval, 10) || 5000;
  let idx = 0;
  let timer = null;
  let paused = false;

  function show(next) {
    const current = messages[idx];
    const incoming = messages[next];
    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    incoming.classList.add('is-active');
    setTimeout(() => current.classList.remove('is-leaving'), 450);
    idx = next;
  }
  function next() { show((idx + 1) % messages.length); }
  function prev() { show((idx - 1 + messages.length) % messages.length); }

  function start() {
    stop();
    if (paused) return;
    timer = setInterval(next, interval);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  bar.querySelectorAll('[data-dir]').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.dataset.dir === 'next' ? next() : prev();
      start(); // reset timer on manual nav
    });
  });

  bar.addEventListener('mouseenter', () => { paused = true; stop(); });
  bar.addEventListener('mouseleave', () => { paused = false; start(); });
  bar.addEventListener('focusin',    () => { paused = true; stop(); });
  bar.addEventListener('focusout',   () => { paused = false; start(); });

  start();
}
